module.exports = __webpack_public_path__ + "static/img/honor5.f749b15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/honor/honor5.png
// module id = 8+Nm
// module chunks = 0